import { Observable } from 'rxjs';

export interface VentilatorPriceSettings {
  id?:number;
  itemId:number;
  type:number;
  fullDayTariff:number;
  halfDayTariff:number;
  hourlyTariff:number;
  isActive:string;
  gstPercentage:number;
  branchId:string;
  tenantId:string;
  createdBy:number;
  createdDate:Date;
  createdIP:string
  updatedBy?:number;
  updatedDate?:Date
  updatedIP :string;
  returnList?:boolean;
}

export abstract class VentilatorPriceSettingsData { 
  abstract list(url: string,data:any): Observable<VentilatorPriceSettings[]>;
  abstract create(url: string,data: VentilatorPriceSettings): Observable<any>;
  abstract update(url: string,data: VentilatorPriceSettings): Observable<any>;
}